import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";
import Link from "next/link";

interface IChangeSimEsimPeselRegisteredErrorProps {
  userId: string | undefined;
}

export function ChangeSimEsimPeselRegisteredError({
  userId,
}: IChangeSimEsimPeselRegisteredErrorProps) {
  return (
    <Panel testId="incorrect-pesel-info-panel">
      <div className="flex flex-col items-center justify-center">
        <Text
          align="center"
          size={{ "@onlyMobile": "xl", "@fromTablet": "keyM" }}
          weight="bold"
        >
          nieudana weryfikacja numeru PESEL
        </Text>
        <Separator size="m" tone="invisible" />
        <Icon
          className="w-[60px] h-[60px] from-tablet:w-[90px] from-tablet:h-[90px]"
          name="wallet-incircle-fail"
        />
        <Separator size="m" tone="invisible" />
        <Text align="center" size={{ "@onlyMobile": "m", "@fromTablet": "xl" }}>
          Rejestr numerów PESEL chwilowo nie odpowiada.{" "}
          <Separator size="none" tone="invisible" /> Spróbuj jeszcze raz za 15
          minut.
        </Text>
        <Separator size="m" tone="invisible" />
        <div className="only-mobile:w-full">
          <Link
            href={portalRoutes.mojeKonto.index.get({
              mode: "mobile",
              ...(userId && { userId }),
            })}
            passHref={true}
          >
            <A
              className="only-mobile:w-full"
              size={{
                "@onlyMobile": "s",
              }}
              testId="ok-button"
              variant="primary"
            >
              ok
            </A>
          </Link>
        </div>
      </div>
    </Panel>
  );
}
